<template>
  <div class="LP-container disp-scroll">
    <LPHeader/>
    <MainCompanyInfo :company=company class="main-info"/>
    <IntroductionTrigger :company=company />
    <Interview :company=company />
    <RecommendTrial>
			<p class="trial-message">
				HRモンスターの導入を検討している、まずは少し試してみたい、という方向けに14日間のトライアルをご用意しております。お気軽にお試しください。
			</p>
		</RecommendTrial>
		<LPFooter/>
  </div>
</template>

<script>
import LPHeader from '@/views/LP/LPHeader'
import RecommendTrial from '@/views/LP/RecommendTrial'
import MainCompanyInfo from '@/components/LP/organisms/MainCompanyInfo'
import IntroductionTrigger from '@/components/LP/organisms/IntroductionTrigger'
import Interview from '@/components/LP/organisms/Interview'
import LPFooter from '@/views/LP/LPFooter'

export default {
	components: {
    LPHeader,
    RecommendTrial,
    MainCompanyInfo,
    IntroductionTrigger,
		Interview,
		LPFooter
	},
	data () {
		return {
			company: this.getCompanyNameFromPath()
		}
	},
	methods: {
		getCompanyNameFromPath () {
			return location.href.split('/').pop()
		}
	}
}
</script>

<style scoped lang="scss">
.LP-container {
	height: 100vh;
	text-align: left;
	font-family: 'Noto Sans Japanese', sans-serif;
	background-color: #fefefe;
	color: #333333;
	position: relative;
	.trial-message {
		font-weight: bold;
	}
	.main-info {
		margin-top: 80px;
	}
}

// deep selector
$h2-font-size: 38px;

.LP-container /deep/ h1 {
  font-size: 54px;
	font-weight: 900;
}
.LP-container /deep/ h2 {
	font-size: $h2-font-size;
	font-weight: bold;
}
.LP-container /deep/ h3 {
	font-size: 24px;
	font-weight: bold;
}
.LP-container /deep/ h4 {
	font-size: 20px;
	font-weight: bold;
}
.LP-container /deep/ .emphasis {
	color: #C4283A;
	font-size: $h2-font-size;
	font-weight: bold;
}
.LP-container /deep/ img {
	vertical-align: bottom;
}
.LP-container /deep/ *:focus {
  outline: none;
}
.LP-container /deep/ .main-section {
	position: relative;
}
.LP-container /deep/ .link-point {
	position: absolute;
	top: -80px;
}
@media screen and (max-width: 1194px) {
	.LP-container /deep/ h1 {
		font-size: 44px;
	}
}
@media screen and (max-width: 1024px) {
	.LP-container /deep/ h1 {
		font-size: 40px;
	}
}
@media screen and (max-width: 950px) {
	.LP-container /deep/ h1 {
		font-size: 58px;
	}
}
@media screen and (max-width: 896px) {
	.LP-container /deep/ h1 {
		font-size: 40px;
	}

	$h2-font-size: 26px;

	.LP-container /deep/ h2 {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ .emphasis {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ h3 {
		font-size: 18px;
		font-weight: bold;
	}
.LP-container /deep/ h4 {
	font-size: 16px;
	font-weight: bold;
}
	.LP-container /deep/ .link-point {
		top: -40px;
	}
}
@media screen and (max-width: 480px) {
	.LP-container /deep/ * {
		font-size: 16px;
	}
	.LP-container /deep/ h1 {
		font-size: 28px;
		font-weight: 900;
	}

	$h2-font-size: 22px;

	.LP-container /deep/ h2 {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ .emphasis {
		font-size: $h2-font-size;
	}
	.LP-container /deep/ h3 {
		font-size: 18px;
		font-weight: bold;
	}
}

@media screen and (max-width: 896px) {
	.LP-container {
		.main-info {
			margin-top: 48px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/CaseStudy.vue